import LoginForm from "../../model/loginForm";

export function updateLoginForm(setState: React.Dispatch<React.SetStateAction<LoginForm>>, name: string, value: string): void {
    setState((state) => ({ ...state, [name]: value }));
}

export function setRememberMe(setState: React.Dispatch<React.SetStateAction<LoginForm>>, value: boolean): void {
    setState((state) => ({ ...state, rememberMe: value }));
}

export function setTerms(setState: React.Dispatch<React.SetStateAction<LoginForm>>, value: boolean): void {
    setState((state) => ({ ...state, terms: value }));
}
